import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Router } from '@angular/router';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import { tap } from 'rxjs/operators';
import { Team, RequestStatus, NGXLogger } from '@app/shared';
import { TeamService } from '@app/core';
import {
  TeamActionTypes,
  GetTeams,
  GetTeamsSuccess,
  GetTeamsFailure,
  GetTeamMembers,
  GetTeamMembersSuccess,
  GetTeamMembersFailure,
  CreateTeam,
  EditTeam,
  UpdateTeam,
  UpdateTeamSuccess,
  UpdateTeamFailure,
  SetTeam,
  SetTeamSuccess,
  SetTeamFailure,
  AddTeamMember,
  AddTeamMemberSuccess,
  AddTeamMemberFailure,
  RemoveTeamMember,
  RemoveTeamMemberSuccess,
  RemoveTeamMemberFailure

} from '../actions/team.actions';


@Injectable()
export class TeamEffects {

  constructor(
    private actions: Actions,
    private teamService: TeamService,
    private router: Router,
    private logger:NGXLogger,
  ) { }

  // effects go here
/*  @Effect()
  GetTeam:Observable<any>= this.actions
    .ofType(AuthActionTypes.LOGIN)
    .map((action: LogIn) => action.payload)
    .switchMap(payload => {
      return this.userService.auth(payload.email, payload.password)
        .map((user) => {
          this.logger.debug(user);
          return new LogInSuccess({token: user.token, email: payload.email});
        })
        .catch((error) => {
          this.logger.debug(error);
          return Observable.of(new LogInFailure({ error: error }));
        });
    });*/
    @Effect()
    UpdateTeam: Observable<any> = this.actions
        .ofType(TeamActionTypes.UPDATE_TEAM)
        .debounceTime(10)
        .map((action: UpdateTeam) => action.payload)
        .switchMap(payload => {
          return this.teamService.updateTeam(payload.team)
            .map((result) => {
              let team : Team = Object.assign( new Team(), result.data[0] );
              team.members = [];
              if(team.tags)
                team.tags = result.data[0].tags.split(',');

              if(!payload.team.id)
                payload.teams.push(team);
              else{
                // find the team in the team list and update it with values
                // from request
                let tmpTeam = payload.teams.find(val => val.id === team.id);
                if(tmpTeam)
                  team = Object.assign( tmpTeam, result.data[0] );
              }
              //payload.team.members.push(payload.member)
              let rs : RequestStatus = new RequestStatus();
              rs.code = result.code;
              rs.msg = `Team has been saved`;

              return new UpdateTeamSuccess({team:team,successStatus:rs});
            })
            .catch((error) => {
              this.logger.debug(error);
              let es : RequestStatus = new RequestStatus();
              es.msg = `Unable to save team`;
              return Observable.of(new UpdateTeamFailure({ errorStatus: es }));
            });
        })

    @Effect({ dispatch: false })
    UpdateTeamSuccess: Observable<any> = this.actions.pipe(
      ofType(TeamActionTypes.UPDATE_TEAM_SUCCESS),
      tap((result) => {
        //this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    UpdateTeamFailure: Observable<any> = this.actions.pipe(
      ofType(TeamActionTypes.UPDATE_TEAM_FAILURE)
    );

    @Effect()
    GetTeams: Observable<any> = this.actions
        .ofType(TeamActionTypes.GET_TEAMS)
        .debounceTime(10)
        .map((action: GetTeams) => action.payload)
        .switchMap(payload => {
          return this.teamService.getGlobalTeams()
            .map((result) => {

              // init team members
              result.data.map(team => {
                team.members = [];
                team.tags = team.tags?team.tags.split(','):null;
                if(team.colour && team.colour.charAt(0) != "#")
                  team.colour = `#${team.colour}`;
              });

              return new GetTeamsSuccess({teams:result.data})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new GetTeamsFailure({ error: error }));
            });
        })



    @Effect({ dispatch: false })
    GetTeamsSuccess: Observable<any> = this.actions.pipe(
      ofType(TeamActionTypes.GET_TEAMS_SUCCESS),
      tap((result) => {
        //this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    GetTeamsFailure: Observable<any> = this.actions.pipe(
      ofType(TeamActionTypes.GET_TEAMS_FAILURE)
    );


    @Effect()
    GetTeamMembers: Observable<any> = this.actions
        .ofType(TeamActionTypes.GET_TEAM_MEMBERS)
        .debounceTime(10)
        .map((action: GetTeams) => action.payload)
        .switchMap(payload => {
          return this.teamService.getTeamMembers(payload.team)
            .map((result) => {
              let members = result.data;
              payload.team.members = members;
              return new GetTeamMembersSuccess({selectedTeam:payload.team})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new GetTeamMembersFailure({ error: error }));
            });
        })

    @Effect({ dispatch: false })
    GetTeamMembersSuccess: Observable<any> = this.actions.pipe(
      ofType(TeamActionTypes.GET_TEAM_MEMBERS_SUCCESS),
      tap((result) => {
        //this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    GetTeamMembersFailure: Observable<any> = this.actions.pipe(
      ofType(TeamActionTypes.GET_TEAM_MEMBERS_FAILURE)
    );



    @Effect()
    AddTeamMember: Observable<any> = this.actions
        .ofType(TeamActionTypes.ADD_TEAM_MEMBER)
        .debounceTime(10)
        .map((action: AddTeamMember) => action.payload)
        .switchMap(payload => {
          return this.teamService.addTeamMember(payload.team,payload.member)
            .map((result) => {
              payload.team.members.push(payload.member)
              return new AddTeamMemberSuccess({selectedTeam:payload.team})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new AddTeamMemberFailure({ error: error }));
            });
        })

    @Effect({ dispatch: false })
    AddTeamMemberSuccess: Observable<any> = this.actions.pipe(
      ofType(TeamActionTypes.ADD_TEAM_MEMBER_SUCCESS),
      tap((result) => {
        this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    AddTeamMemberFailure: Observable<any> = this.actions.pipe(
      ofType(TeamActionTypes.ADD_TEAM_MEMBER_FAILURE)
    );

    @Effect()
    RemoveTeamMember: Observable<any> = this.actions
        .ofType(TeamActionTypes.REMOVE_TEAM_MEMBER)
        .debounceTime(10)
        .map((action: RemoveTeamMember) => action.payload)
        .switchMap(payload => {
          return this.teamService.removeTeamMember(payload.team,payload.member)
            .map((result) => {

              let idx = payload.team.members.findIndex(member => member.uuid === payload.member.uuid);
              if(idx > -1)
                payload.team.members.splice(idx,1);

              return new RemoveTeamMemberSuccess({selectedTeam:payload.team})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new RemoveTeamMemberFailure({ error: error }));
            });
        })

    @Effect({ dispatch: false })
    RemoveTeamMemberSuccess: Observable<any> = this.actions.pipe(
      ofType(TeamActionTypes.REMOVE_TEAM_MEMBER_SUCCESS),
      tap((result) => {
        this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    RemoveTeamMemberFailure: Observable<any> = this.actions.pipe(
      ofType(TeamActionTypes.REMOVE_TEAM_MEMBER_FAILURE)
    );

    // SETTING CURRENT Team
    @Effect()
    /*SetTeam: Observable<any> = this.actions
        .ofType(TeamActionTypes.SET_TEAM)
        .map((action: GetTeams) => action.payload)
        .switchMap(payload => {
          return this.teamService.getTeam(payload.team)
            .map((result) => {
              this.logger.debug(result.data);
              //return new LogInSuccess({token: user.token, email: payload.email});
              return new SetTeamSuccess({selectedTeam:payload.team})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new SetTeamFailure({ error: error }));
            });
        });*/


    @Effect({ dispatch: false })
    SetTeamSuccess: Observable<any> = this.actions.pipe(
      ofType(TeamActionTypes.SET_TEAM_SUCCESS),
      tap((result) => {

        this.logger.debug(result)
        // localStorage.setItem('token', user.payload.token);
        // this.router.navigateByUrl('/main');
      })
    );

    @Effect({ dispatch: false })
    SetTeamFailure: Observable<any> = this.actions.pipe(
      ofType(TeamActionTypes.SET_TEAM_FAILURE)
    );
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/effects/team.effects.ts